import { regionalizePath } from '../config/branches-config';

type LocalizePath = (path: string) => string;

/** Строит конечный URL товара без двойных слешей и лишнего редиректа. */
export function productItemPath(
    itemCode: unknown,
    branchCode: string,
    localizePath: LocalizePath = (path) => path,
    fromBranchCode?: string,
): string {
    const normalizedCode = String(itemCode ?? '')
        .trim()
        .replace(/^\/+|\/+$/g, '');
    const basePath = normalizedCode ? `/shop/item/${normalizedCode}` : '/shop/item';

    return regionalizePath(localizePath(basePath), branchCode, fromBranchCode);
}
